import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { CareerOneStopTrainingFilters } from 'tuapath-common/generated/schema';


type Results = {
  user: {
    trainingFilters: CareerOneStopTrainingFilters;
  };
};
type Variables = {
  userId: number;
  zip?: string;
};

export const useTrainingFilters = (options?: QueryHookOptions<Results, Variables>) => {
  const query = gql`
    query getTrainingFilters($userId: Int!, $zip: String!) {
      user(id: $userId) {
        id
        trainingFilters(zip: $zip) {
          occupationList {
            filterList {
              item
              count
              value
            }
          }
          programCountList {
            filterList {
              item
              count
              value
            }
          }
          programLengthCountList {
            filterList {
              item
              count
              value
            }
          }
        }
      }
    }
  `;

  return useQuery<Results, Variables>(query, options);
};

export default useTrainingFilters;
